import api from '../api'

export function fetchIdentities() {
	return (dispatch) => api.fetch('/identities')
		.then((response) => {
			return response
		})
		 .catch(err => {
		 	
		     
	  })


}



 //For old ISBE claim flow

// export function fetchIdentity(id,token) {

// 	return (dispatch) => api.fetch(`/identities/${id}?token=${token}`)
// 		.then((response) => {
// 			return response
// 		})
// 		 .catch(err => {

// 		 	const url=window.location.href
// 		     Sentry.withScope(scope => {
// 				scope.setExtra('url',url )
// 				Sentry.captureMessage('GET /identities/:id Error')
// 			})
// 		     throw err
// 	  })


// }



// export function claimIdentity(id,token) {
// 	return (dispatch) => api.post(`/identities/${id}/claim?token=${token}`)
// 		.then((response) => {
// 			return response
// 			// dispatch({ type: 'FETCH_IDENTITIES_SUCCESS', response })
// 		})

// }

// export function reserveIdentity(identity,token) {
// 	return (dispatch) => api.put(`/identities/${identity}/reserve?token=${token}`)
// 		.then((response) => {
// 			return response

// 			// dispatch({ type: 'FETCH_IDENTITIES_SUCCESS', response })
// 		})

// }



// WEBPACK FOOTER //
// ./src/actions/identities.js